import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        property_setting: [],
        property_settings: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        property_setting: state => state.property_setting,
        property_settings: state => state.property_settings,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setPropertySettings(state, data) {
            state.property_settings = data;
        },
        setPropertySetting(state, data) {
            state.property_setting = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async getPropertySetting({commit}, property_setting_id) {
            try {
                const response = await api.getPropertySetting(property_setting_id);
                commit('setPropertySetting', response.data)
            } catch (e) {
                ElMessage.error("")
            }
        },
        async getPropertySettings({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'property_setting/list', {root: true});
                const response = await api.getPropertySettings(filters);
                commit('setPropertySettings', response);
                commit('deactivateLoading', 'property_setting/list', {root: true});
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e?.response?.data?.message);
            }
        },
        async createPropertySettings({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createPropertySetting(data);
                commit('setLoading', false)
                ElMessage.success('Settings created successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editPropertySetting({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editPropertySetting(data);
                dispatch('getPropertySettings', {
                    paginate: true
                });
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deletePropertySetting({dispatch}, data) {
            try {
                await api.deletePropertySetting(data);
                dispatch('getPropertySettings', {
                    paginate: true
                })
                ElMessage.success("Settings removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Settings');
                }
            }
        }
    }
}
